<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Loading from "@/components/c-loading";
import i18n from "../../../../../i18n";
import { sellertypeService } from "../../../../../services/settingservice/configurationservice/sellertype.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Seller Type",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Seller Type",
      breadCrumb: {},

      sellerType: {},
      valueName: '',
      valueNameEn: '',

    };
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      sellertypeService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.sellerType = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueName = this.sellerType.name;
          this.valueNameEn = this.sellerType.name_en;

        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-seller-type"
          });

        }
      });
      
    },

    submitSave: function() {

      this.tryingToSubmit = true;

      let sellerType = {
        name: this.valueName,
        name_en: this.valueNameEn,
      };

      // console.log(JSON.stringify(sellerType));

      if(this.isAdd) {
        sellertypeService.insert(sellerType)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "setting-seller-type"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(seller));
        sellertypeService.update(this.$route.params.id, sellerType)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-seller-type"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.valueName = '';
      this.valueNameEn = '';
    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.configuration.seller-type.text'),
        href: '/setting/seller/type',
      }, {
        text: $t('setting.configuration.seller-type.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.configuration.seller-type.new') : $t('setting.configuration.seller-type.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.configuration.seller-type.text'),
        href: '/setting/seller/type',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.configuration.seller-type.new') : $t('setting.configuration.seller-type.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />


    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
           
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :label="'setting.configuration.seller-type.name'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :label="'setting.configuration.seller-type.name-en'"  />
              </div>
            </div>
            <div class="row">
              <div inline class="row gy-2 gx-3 align-items-end">
                <div class="col-sm-auto">
                  <Button v-bind:icon="'bx bx-x-circle'" 
                    v-bind:buttonType="'button'"
                    v-bind:variant="'danger'"
                    @click="submitCancel()"
                    v-bind:title="$t('general.cancel')"  />
                </div>
                <div class="col-sm-auto">
                  <Button v-bind:icon="'bx bx-save bx-tada'" 
                    v-bind:buttonType="'button'"
                    @click="submitSave()"
                    v-bind:requesting="tryingToSubmit"
                    v-bind:title="$t('general.save')"  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </b-form> 

  </Layout>
</template>